<template>
  <div class="welcome-wrap">
    <div class="welcome">
      <div class="content">
        <div class="top-cont">
          <h3>{{ $t('seller.dashboard.welcomeCongrats') }}</h3>
          <p>{{ $t('seller.dashboard.welcomeCompleteSteps') }}</p>
          <div class="item item-first">
            <div class="head">
              <span class="circel">1</span>
              <span class="text">{{ $t('seller.dashboard.welcomeStep1Title') }}</span>
            </div>
            <div class="item-content">
              <a-timeline>
                <a-timeline-item>{{ $t('seller.dashboard.welcomeStep1Item1') }}</a-timeline-item>
                <a-timeline-item>{{ $t('seller.dashboard.welcomeStep1Item2') }}</a-timeline-item>
              </a-timeline>
              <div class="btn">
                <a href="/seller/brand/index">
                  <artmisads-button type="primary">
                    {{ $t('seller.dashboard.welcomeStep1Title') }}
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-jiantou-you-cu"></use>
                    </svg>
                  </artmisads-button>
                </a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="head">
              <span class="circel">2</span>
              <span class="text">{{ $t('seller.dashboard.welcomeStep2Title') }}</span>
            </div>
            <div class="item-content">
              <a-timeline>
                <a-timeline-item>{{ $t('seller.dashboard.welcomeStep2Item1') }}</a-timeline-item>
                <a-timeline-item>{{ $t('seller.dashboard.welcomeStep2Item2') }}</a-timeline-item>
                <a-timeline-item>{{ $t('seller.dashboard.welcomeStep2Item3') }}</a-timeline-item>
                <a-timeline-item>{{ $t('seller.dashboard.welcomeStep2Item4') }}</a-timeline-item>
              </a-timeline>
              <div class="btn">
                <a href="/seller/product">
                  <artmisads-button type="primary">
                    {{ $t('seller.dashboard.welcomeStep2Title') }}
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-jiantou-you-cu"></use>
                    </svg>
                  </artmisads-button>
                </a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="head">
              <span class="circel">3</span>
              <span class="text">{{ $t('seller.dashboard.welcomeStep3Title') }}</span>
            </div>
            <div class="item-content">
              <div class="mail">
                <img src="../../../assets/images/admin/welcome/mail.png" />
                <a>Support@ArtemisAds.com</a>
              </div>
              <div class="address">
                <img src="../../../assets/images/admin/welcome/address.png" />
                <span>{{ $t('seller.dashboard.welcomeAddress') }}</span>
              </div>
              <div class="qr-code">
                <img
                  src="../../../assets/images/admin/welcome/app_downlaod.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-cont">
          <span>{{ $t('seller.dashboard.welcomeThanks') }}</span>
          <span>{{ $t('seller.dashboard.welcomeTeam') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.welcome-wrap {
  width: 100%;
  height: 100%;
  padding: 24px;
}
.welcome {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .warning {
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    .show-brand {
      position: absolute;
      bottom: 10px;
      right: 50%;
      margin-right: -320px;
    }
    :deep(.ant-alert) {
      width: 690px;
      padding-bottom: 50px;
    }
  }
  .content {
    align-self: center;
    width: 690px;
    background: var(--color-white);
    box-shadow: var(--section-box-shadow-2);
    border-radius: 8px;
  }
  .item {
    margin-top: 48px;
    .head {
      display: flex;
      .circel {
        width: 24px;
        height: 24px;
        background: var(--primary-icon);
        border-radius: 12px;
        box-shadow: 0px 0px 0px 5px var(--primary-icon-border);
        text-align: center;
        line-height: 24px;
        color: var(--color-white);
        font-weight: 500;
        font-size: var(--font-size-large);
      }
      .text {
        font-size: var(--font-size-h-l);
        color: var(--dark-1);
        font-weight: 500;
        line-height: 24px;
        margin-left: 17px;
      }
    }
    .item-content {
      margin-left: 41px;
      :deep(.ant-timeline) {
        margin-top: 13px;
        .ant-timeline-item-content {
          color: var(--dark-2);
          line-height: 22px;
        }
        .ant-timeline-item-head {
          width: 10px;
          height: 10px;
          background: var(--border-1);
          border: 2px solid var(--color-white);
          border-radius: 5px;
          box-shadow: 0px 0px 0px 2px var(--border-1);
        }
      }
    }
    .btn {
      button {
        svg {
          width: 18px;
          height: 18px;
          margin-left: 9px;
        }
      }
    }
  }
  .item-first {
    margin-top: 42px;
  }
  .top-cont {
    padding: 0 37px 40px 48px;
    > h3 {
      font-size: 28px;
      line-height: 38px;
      color: var(--dark-1);
    }
    > p {
      margin-top: 12px;
      line-height: 20px;
      color: var(--dark-1);
    }
    .address,
    .mail {
      display: flex;
      > img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        align-self: center;
      }
    }
    .address {
      margin-top: 12px;
      > span {
        font-size: var(--font-size-large);
        letter-spacing: 0;
        line-height: 24px;
        color: var(--dark-2);
      }
    }
    .mail {
      margin-top: 16px;
      > a {
        height: 24px;
        font-size: var(--font-size-large);
        color: var(--dark-1);
        letter-spacing: 0;
        line-height: 24px;
        text-decoration: underline;
      }
    }
    .qr-code {
      margin-top: 16px;
      width: 100px;
      height: 100px;
      box-shadow: var(--section-box-shadow-2);
      border-radius: 4px;
    }
  }
  .bottom-cont {
    height: 64px;
    background: var(--bg-gray-1);
    border-radius: 0 0 8px 8px;
    text-align: right;
    display: flex;
    flex-direction: column;
    padding-right: 24px;
    padding-top: 14px;
    > span {
      font-size: 13px;
      color: var(--dark-4);
      text-align: right;
      line-height: 18px;
    }
  }
}
</style>
